import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrl: './questionnaire.component.scss'
})
export class QuestionnaireComponent implements OnInit{
  constructor(
    private router: Router,
    private authService: AuthService
  ){

  }
  ngOnInit(): void {

    if(this.authService.isStaff() || this.authService.isAdmin()){
      this.router.navigate(['']);
    }
  }
}
